var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"label":"Gymnasisereform","items":_vm.reforms,"outlined":""},model:{value:(_vm.selectedReform),callback:function ($$v) {_vm.selectedReform=$$v},expression:"selectedReform"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }